import { generatePath, useLocation } from 'react-router-dom';
import ACTIVITY_TYPES from '../../constants/day-orchestrator-activity-types';
import APP_ROUTES from '../../constants/app-routes';
import ActivityNotification from './activity-notification';
import ContentWithHeading from '../../layouts/content-with-heading';
import PropTypes from 'prop-types';
import React from 'react';
import ScheduledEventNotification from './scheduled-event-notification';
import classNames from 'classnames';
import useNextActivity from '../../hooks/data-access/use-next-activity';
import { useTranslation } from 'react-i18next';

//

function _getActivityProps(activityData, activityType, translate) {
  if (!activityData) {
    return {};
  }

  if (activityType === ACTIVITY_TYPES.assignment) {
    return {
      actionText: translate('assignmentActionText'),
      analyticsAction: 'assignment-redirect',
      detailPath: generatePath(APP_ROUTES.assignedSkillOverview, {
        assignmentId: activityData.assignment_id,
        skillId: activityData.skill.skill_id,
        subjectId: activityData.skill.subject_id,
      }),
      notificationTitle: translate('assignmentNotificationTitle', {
        assignment: activityData.skill.skill_name,
      }),
    };
  }

  return {
    actionText: translate(
      activityData.iteration ? 'reassessmentActionText' : 'assessmentActionText'
    ),
    analyticsAction: 'assessment-redirect',
    detailPath: generatePath(APP_ROUTES.assessments, {
      assessmentId: activityData.assessmentId,
    }),
    notificationTitle: translate(
      activityData.iteration ? 'reassessmentNotificationTitle' : 'assessmentNotificationTitle',
      { assessment: activityData.subjectName }
    ),
  };
}

//

function DayOrchestrator({ alwaysTakeUpSpace = false, withoutHeading = false }) {
  const { t: translate, ready: translationLoaded } = useTranslation('day-orchestrator/index');

  const { type: activityType, data: activityData } = useNextActivity();

  const { pathname } = useLocation();

  const className = classNames('day-orchestrator', {
    'day-orchestrator--without-heading': withoutHeading,
  });

  //
  // Render

  const { actionText, analyticsAction, detailPath, notificationTitle } = _getActivityProps(
    activityData,
    activityType,
    translate
  );

  if (!translationLoaded || !activityData || pathname === detailPath) {
    if (alwaysTakeUpSpace) {
      return <div {...{ className }} />;
    }

    return null;
  }

  return (
    <ContentWithHeading {...{ className }} heading={withoutHeading ? null : translate('heading')}>
      {activityType === ACTIVITY_TYPES.session ? (
        activityData.map((event) => (
          <ScheduledEventNotification {...{ event }} key={event.sessionId} />
        ))
      ) : (
        <ActivityNotification
          actionText={actionText}
          analytics={{
            action: analyticsAction,
            category: 'day-orchestrator',
          }}
          url={detailPath}
        >
          {notificationTitle}
        </ActivityNotification>
      )}
    </ContentWithHeading>
  );
}

DayOrchestrator.propTypes = {
  alwaysTakeUpSpace: PropTypes.bool,
  withoutHeading: PropTypes.bool,
};

// Exports
// -------

export default DayOrchestrator;
